import { useMutation } from "react-query";
import { getResubscribeURL } from "@/api/purchase.ts";
import { AxiosError } from "axios";

export const useResubscribeURL = () => {
  return useMutation<string, AxiosError>(() => {
    return getResubscribeURL();
  });
};
